import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "bigImg"
};
const _hoisted_2 = {
  class: "swiper-wrapper"
};
const _hoisted_3 = {
  class: "swiper-slide"
};
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "placeHolderImg",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$parent.showBigImg = false)
  }), _createElementVNode("div", {
    class: "swiper-container swiperImg",
    ref: "swiperBigImg",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$parent.showBigImg = false),
    onTouchstart: _cache[2] || (_cache[2] = (...args) => $options.onTouchStart && $options.onTouchStart(...args)),
    onTouchmove: _cache[3] || (_cache[3] = (...args) => $options.onTouchMove && $options.onTouchMove(...args)),
    onTouchend: _cache[4] || (_cache[4] = (...args) => $options.onTouchEnd && $options.onTouchEnd(...args)),
    style: _normalizeStyle(`transform: scale(${$data.scaleNum})`)
  }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.imgs, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_4)]);
  }), 256))]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))], 36)]);
}